import store from "../redux/Store";
import {set} from "../redux/Action";
import Objects from "../redux/Objects";

export function show(msg) {
    let msgKey = msg + 'show';
    if(Date.now() - parseInt(localStorage.getItem(msgKey)) < 5000) return;

    store.dispatch(set(Objects.toast,true))
    store.dispatch(set(Objects.toastMsg,msg))
    setTimeout(() => {
        store.dispatch(set(Objects.toast,false))
    },4500)

    localStorage.setItem(msgKey, Date.now().toString());
}

export function error(msg) {
    let msgKey = msg + 'error';
    if(Date.now() - parseInt(localStorage.getItem(msgKey)) < 5000) return;

    store.dispatch(set(Objects.toast,true))
    store.dispatch(set(Objects.toastMsg,msg))
    setTimeout(() => {
        store.dispatch(set(Objects.toast,false))
    },4500)

    localStorage.setItem(msgKey, Date.now().toString());
}

export function success(msg) {
    let msgKey = msg + 'success';
    if(Date.now() - parseInt(localStorage.getItem(msgKey)) < 5000) return;

    store.dispatch(set(Objects.toast,true))
    store.dispatch(set(Objects.toastMsg,msg))
    setTimeout(() => {
        store.dispatch(set(Objects.toast,false))
    },4500)

    localStorage.setItem(msgKey, Date.now().toString());
}
